import { render, staticRenderFns } from "./PressDieInfo.vue?vue&type=template&id=2ca9c0b9&"
import script from "./PressDieInfo.vue?vue&type=script&lang=js&"
export * from "./PressDieInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports